exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".embed-table-wrapper[data-v-8f7c43c0]{width:100%;padding-bottom:10px}", ""]);

// exports
